import React, { useEffect, useState } from "react";
import InnerHead from "../components/InnerHead";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Cta from "../components/Cta";
import { client } from "../config/prismic";

const Past = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("past_conference");
      setData(response.results.map((result) => result.data)); // Map to simplify access to conference data
    };
    fetchData();
  }, []);

  if (!data) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div>
      <Header page={true} />
      <Cta />
      <div className="container section-title mt-4 pt-4" data-aos="fade-up">
        <h2 className="">Past Conferences</h2>
        <p className=""></p>
      </div>
      <div className="container my-5">
        {/* Iterate over each conference collection */}
        {data.map((conferenceData, index) =>
          conferenceData.collection.map((conference, confIndex) => (
            <div
              key={`${index}-${confIndex}`}
              className="card shadow-lg bg-red text-white my-4"
            >
              <div className="card-body text-center">
                <h3 className="card-title mb-3">{conference.title[0]?.text}</h3>
                <p className="card-text">
                  <strong>Venue:</strong> {conference.venue[0]?.text}
                </p>
                <p className="card-text">
                  <strong>Date:</strong> {conference.date[0]?.text}
                </p>
                <p className="card-text">{conference.description[0]?.text}</p>
                <p className="card-text">
                  <strong>{conference.acroynm[0]?.text}</strong>
                </p>
                {/* <p className="card-text">
                  <strong>IEEE Catalog Number:</strong>{" "}
                  {conference.catalog_number[0]?.text}
                </p> */}
                <p className="card-text">
                  <strong>DOI:</strong> 10.1109/INNOCOMP63224.2024
                </p>
                <p className="card-text">
                  <strong>ISBN:</strong> {conference.isbn[0]?.text}
                </p>
                {conference.proceedings_link[0]?.text && (
                  <a
                    href={conference.proceedings_link[0].text}
                    className="register-btn bg-dark-blue mt-4 mx-2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Xplore Proceedings Link
                  </a>
                )}
                <a
                  href="https://www.computer.org/csdl/proceedings/innocomp/2024/20jq50O7NBu"
                  className="register-btn bg-dark-blue mt-4 mx-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CSDL Link
                </a>
                <a
                  href="https://www.scopus.com/freelookup/form/author.uri?zone=TopNavBar&origin=NO%20ORIGIN%20DEFINED"
                  className="register-btn bg-dark-blue mt-4 mx-2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Scopus Link
                </a>
              </div>
            </div>
          ))
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Past;
